var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"ce-html"},[_c('html-parser',{attrs:{"content":_vm.props.bodytext}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }